<script>
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'GeneratePDFButton',
  props: ['expedition'],
  components: {
    VueHtml2pdf,
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<template>
  <div>
    <button
      @click="generateReport"
      class=" text-gray-700 font-bold rounded mr-4 hover:text-orange-900"
    >
      <span class="material-icons">
        confirmation_number
      </span>
    </button>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="ticket"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section class="pdf-content" slot="pdf-content">
        <!-- PDF Content Here -->
        <section class="report-info">
          <div style="margin-top: 10px;">
            <h4>
              <span style="font-weight: bold; margin-right: 20px;"
                >Sender: </span
              >{{ expedition.seller.company }}
            </h4>
            <h4>
              <span style="font-weight: bold;margin-right: 20px;"
                >Tracking Number: </span
              >{{ expedition.trackingNumber }}
            </h4>
          </div>
          <section class="image-container">
            <img
              class="user-image"
              src="/1687621163901.png"
              alt="User Image"
              ref="userImage"
            />
          </section>
        </section>
        <section style="padding: 20px;">
          <h3
            class="text-lg font-bold text-gray-900 dark:text-white"
            style="margin: 20px 0px; "
          >
            Shipment Details
          </h3>
          <table
            class="w-full text-sm text-left text-gray-800 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
            >
              <tr>
                <th scope="col" class="px-6 py-3">
                  Product name
                </th>
                <th scope="col" class="px-6 py-3">
                  Quantity
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in expedition.details"
                :key="item.product && item.product._id"
                class="bg-white dark:bg-gray-800"
              >
                <th
                  scope="row"
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ item.product.name }}
                </th>
                <td class="px-6 py-4">
                  {{ item.quantity.sent }}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <div
          style="display: flex; align-items: center; justify-content: center; width: 100%;"
        >
          <vue-barcode
            :value="expedition.trackingNumber || expedition.id"
          ></vue-barcode>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>

<style scoped>
.pdf-content {
  width: 100%;
  background: #fff;
}
.pdf-content .report-info {
  display: flex;
  padding: 20px;
  padding-bottom: 0px;
  align-items: center;
  justify-content: space-between;
}
.pdf-content .report-info .image-container {
  width: 275px;
  height: 75px;
  position: relative;
  margin-right: 25px;
}
.pdf-content .report-info .image-container .user-image {
  height: 100%;
  min-width: 100%;
  margin-left: 50%;
  transform: translateX(-50%);
}
.pdf-content .report-info .user-details {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.pdf-content .report-info .user-details .user-name {
  margin-bottom: 10px;
  flex-shrink: 0;
}
.pdf-content .report-info .user-details .detail-container {
  font-size: 13px;
  flex-shrink: 0;
}
.pdf-content .report-info .user-details .detail-container:not(:last-child) {
  margin-bottom: 10px;
}
.pdf-content .report-info .user-details .detail-container .detail-label {
  font-weight: 600;
  margin-right: 5px;
  font-size: 13px;
}
.pdf-content .chart-container {
  width: 100%;
  height: 320px;
  padding: 20px;
  pointer-events: none;
}
.pdf-content .chart-container:not(:last-child) {
  margin-bottom: 15px;
}
.pdf-content {
  width: 100%;
  background: #fff;
}
.pdf-content .report-info {
  display: flex;
  padding: 20px;
  padding-bottom: 0px;
}

.user-imag {
  max-width: 500px;
  max-height: 500px;
}
</style>
